document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-gallery]').forEach((gallery) => {
    const images = [...gallery.querySelectorAll('.gallery-image')];
    const thumbs = [...gallery.querySelectorAll('[data-gallery-thumb]')];
    const count = gallery.querySelector('[data-gallery-count]');
    if (!images.length) return;
    let index = 0;
    const show = (next) => {
      index = (next + images.length) % images.length;
      images.forEach((image, i) => {
        image.classList.toggle('is-active', i === index);
        image.style.display = i === index ? 'block' : 'none';
      });
      thumbs.forEach((thumb, i) => thumb.setAttribute('aria-current', i === index ? 'true' : 'false'));
      if (count) count.textContent = `${index + 1} / ${images.length}`;
    };
    gallery.querySelector('[data-gallery-prev]')?.addEventListener('click', () => show(index - 1));
    gallery.querySelector('[data-gallery-next]')?.addEventListener('click', () => show(index + 1));
    thumbs.forEach((thumb) => thumb.addEventListener('click', () => show(Number(thumb.dataset.galleryThumb))));
    const dialog = document.querySelector('[data-image-dialog]');
    const dialogImage = dialog?.querySelector('[data-dialog-image]');
    gallery.querySelector('[data-gallery-zoom]')?.addEventListener('click', () => {
      const active = images[index];
      if (!dialog || !dialogImage || !active) return;
      dialogImage.src = active.currentSrc || active.src;
      dialogImage.alt = active.alt;
      dialog.showModal();
    });
    dialog?.querySelector('[data-dialog-close]')?.addEventListener('click', () => dialog.close());
    dialog?.addEventListener('click', (event) => {
      if (event.target === dialog) dialog.close();
    });
    show(0);
  });

  document.querySelectorAll('[data-product-root]').forEach((root) => {
    const select = root.querySelector('[data-variant-select]');
    const price = root.querySelector('[data-product-price]');
    if (select && price) select.addEventListener('change', () => {
      price.textContent = select.options[select.selectedIndex].dataset.price || '';
    });
    const form = root.querySelector('.product-form');
    const status = root.querySelector('[data-form-status]');
    if (!form) return;
    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      const button = form.querySelector('[name="add"]');
      button.disabled = true;
      try {
        const response = await fetch('/cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) });
        if (!response.ok) throw new Error('No pudimos agregar el producto.');
        status.textContent = 'Producto agregado. Abriendo tu carrito...';
        window.location.href = '/cart';
      } catch (error) {
        status.textContent = error.message;
        button.disabled = false;
      }
    });
  });
});
